export default "__VITE_PUBLIC_ASSET__2c4cfcc5__"